// extracted by mini-css-extract-plugin
export default {"ordersContainer":"Orders_ordersContainer__Iz6lX","ordersEmptyContainer":"Orders_ordersEmptyContainer__2V8Xr"};